var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('px-span-tooltip',{attrs:{"top":"","text":_vm.labelCompra,"tooltip":_vm.tooltipCompra}})}
var staticRenderFns = []

export { render, staticRenderFns }